import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Thead.css';

const Thead = ({ children, className, ...rest }) => (
  <thead className={classNames('thead', className)} {...rest} >
    { children }
  </thead>
);

Thead.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Thead;



// WEBPACK FOOTER //
// ./src/components/Thead/Thead.jsx